export const REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
export const FAILED = 'SA_PROFILE_VIEW_FAILED';
export const SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
export const PUBLIC_ATHLETE_REQUEST = 'PUBLIC_ATHLETE_REQUEST';
export const CURRENT_VIDEO_URL = 'CURRENT_VIDEO_URL';
export const PUBLIC_ADD_CONVERSATION_REQUESTED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
export const PUBLIC_ADD_CONVERSATION_FAILED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
export const ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL = 'ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/containers/PublicAthletePage/actionTypes.js